<style>
  .animate-in {
    animation: slide-up 0.4s ease;
  }

  @keyframes slide-up {
    0% {
      opacity: 0;
      transform: translateY(-30px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>
<template>
  <div class="modal-window large split active">
    <overlay-scrollbars
      :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <div class="grid-x split">
        <div class="cell large-12 flex-column">
          <div class="modal-window-header gray">
            <div class="modal-window-heading">
              <h3 class="icon-heading small">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use
                xlink:href="/static/sprites.svg#button-glyph-print"></use></svg></span>
                <span class="icon-heading-title">
                <span class="title" v-if="!completed">Kreditering av #{{ invoiceNumber }}</span>
                <span class="title" v-else>Kreditnota for #{{ invoiceNumber }}</span>
              </span>
              </h3>
            </div>
          </div>
          <div class="modal-window-body">
            <div v-if="bilag.bilagslinje.length > 0 && !completed">
              <br>
              <h2>Originalt Bilag</h2>
              <table class="medium padding margin-top margin-bottom">
                <thead>
                <tr>
                  <th></th>
                  <th>Beskrivelse</th>
                  <th>Kode</th>
                  <th class="align-right">Antall</th>
                  <th class="align-right">Pris</th>
                  <th class="align-right">Ink. mva</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="line in bilag.bilagslinje" v-bind:key="line.Bilagslinjeid" @click="toggleBilagslinje(line)">
                  <td style="width:16px;">
                    <div class="input-container checkbox" v-if="line.is_credited === false">
                      <input type="checkbox" name="credit" id="credit"
                             :checked="creditBilagslinjer.find(x => x.Bilagslinjeid == line.Bilagslinjeid && x.is_credited == false)">
                      <span class="glyph"><svg viewBox="0 0 16 16"><use
                        xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
                    </div>
                  </td>
                  <td>
                    <span>{{line.Beskrivelse | truncate(80)}}</span>
                  </td>
                  <td>
                    <span class="label">{{line.Varenr}}</span>
                  </td>
                  <td class="align-right">
                    <span>{{line.Antall}}</span>
                  </td>
                  <td class="align-right">
                    <span>{{line.Belop}}</span>
                  </td>
                  <td class="align-right opacity-60">
                    {{line.Beloptotal}}
                  </td>
                </tr>
                </tbody>
                <tfoot class="highlight">
                <tr>
                  <td colspan="4"><strong>Total</strong></td>
                  <td colspan="1" class="align-right"><strong>{{totalPriceExc}}</strong></td>
                  <td colspan="1" class="align-right"><strong>{{totalPriceInc}}</strong></td>
                  <td>&nbsp;</td>
                </tr>
                </tfoot>
              </table>
            </div>
            <div v-if="creditBilagslinjer.length > 0" class="animate-in">
              <hr>
              <br>
              <h2>Kreditnota</h2>
              <table class="medium padding margin-top margin-bottom">
                <thead>
                <tr>
                  <th>Beskrivelse</th>
                  <th>Kode</th>
                  <th class="align-right">Antall</th>
                  <th class="align-right">Pris</th>
                  <th class="align-right">Ink. mva</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="line in creditBilagslinjer" v-bind:key="line.Internalid" class="animate-in">
                  <td>
                    <span>{{line.Beskrivelse | truncate(80)}}</span>
                  </td>
                  <td>
                    <span class="label">{{line.Varenr}}</span>
                  </td>
                  <td class="align-right">
                    <span>{{line.Antall}}</span>
                  </td>
                  <td class="align-right">
                    <span>{{line.showingBelop}}</span>
                  </td>
                  <td class="align-right opacity-60">
                    {{line.showingBeloptotal}}
                  </td>
                </tr>
                </tbody>
                <tfoot class="highlight">
                <tr>
                  <td colspan="3"><strong>Total</strong></td>
                  <td class="align-right"><strong>{{totalCreditPriceExc}}</strong></td>
                  <td class="align-right"><strong>{{totalCreditPriceInc}}</strong></td>
                  <td>&nbsp;</td>
                </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="modal-window-footer">
            <div class="grid-x">
              <div class="cell align-right">
                <a href="javascript:;" @click="closeButtonClick()"
                   class="button primary transparent large modal-close show-for-medium" v-if="!completed">Avbryt</a>
                <a href="javascript:;" @click="closeButtonClick()"
                   class="button primary transparent large modal-close show-for-medium" v-else>Lukk</a>
                <a href="javascript:;" v-if="!completed" @click="openSaveModal()" class="button primary submit large">Krediter</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </overlay-scrollbars>
  </div>
</template>

<script>

import accounting from 'accounting-js'
import bus from '@/plugins/event-bus'

export default {
  name: 'KrediteringsBilagModal',
  props: {
    bilag: {
      type: Object,
      required: true
    },
    kunde: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      completed: false,
      creditBilagslinjer: []
    }
  },
  created () {
    this.setFormLoading(true)
  },
  mounted () {
    this.bilag.bilagslinje.forEach(x => this.toggleBilagslinje(x))
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()
    bus.$on('invoice-created', (data) => this.onInvoiceCreated(data))
  },
  computed: {
    invoiceNumber: function () {
      if (this.bilag) {
        return this.bilag.twentyfourseven_invoice_id && this.bilag.Dato > '2019-12-31'
          ? this.bilag.twentyfourseven_invoice_id
          : this.bilag.Bilagsnr
      }

      return null
    },
    totalPriceInc: function () {
      let retval = 0

      this.bilag.bilagslinje.forEach((line) => {
        if (line.Beloptotal !== null && line.Beloptotal !== '') {
          retval += parseFloat(line.Beloptotal)
        }
      })

      return accounting.formatNumber(retval, {precision: 2, thousand: ''})
    },
    totalPriceExc: function () {
      let retval = 0

      this.bilag.bilagslinje.forEach((line) => {
        if (line.Belop !== null && line.Belop !== '') {
          retval += parseFloat(line.Belop)
        }
      })

      return accounting.formatNumber(retval, {precision: 2, thousand: ''})
    },
    totalCreditPriceExc: function () {
      let retval = 0
      if (this.creditBilagslinjer.length > 0) {
        this.creditBilagslinjer.forEach((line) => {
          if (line.Belop !== null && line.Belop !== '') {
            retval += parseFloat(line.showingBelop)
          }
        })
      }
      return accounting.formatNumber(retval, {precision: 2, thousand: ''})
    },
    totalCreditPriceInc: function () {
      let retval = 0
      if (this.creditBilagslinjer.length > 0) {
        this.creditBilagslinjer.forEach((line) => {
          if (line.Beloptotal !== null && line.Beloptotal !== '') {
            retval += parseFloat(line.showingBeloptotal)
          }
        })
      }
      return accounting.formatNumber(retval, {precision: 2, thousand: ''})
    }
  },
  methods: {
    onInvoiceCreated: function (data) {
      this.$helpers.showSuccessAlert('Faktura er lagret')
      this.completed = true
      this.$store.dispatch('kundebilag/load', this.kunde.Kundenr)

      // Reload some lists, in case objects where updated during invoice creation
      this.$store.dispatch('kundeobjektbuyerinvoice/load', this.kunde.Kundenr)
      this.$store.dispatch('kundeobjektbuyer/load', this.kunde.Kundenr)
      this.$store.dispatch('kundeobjektdeliver/load', this.kunde.Kundenr)
    },
    toggleBilagslinje: function (line) {
      let found = this.creditBilagslinjer.find(x => x.Bilagslinjeid === line.Bilagslinjeid)

      if (found) {
        this.creditBilagslinjer = this.creditBilagslinjer.filter(x => x.Bilagslinjeid !== line.Bilagslinjeid)
        return
      }

      if (line.is_credited === true) {
        return
      }

      line = Object.assign({}, line)
      line.Antall = -line.Antall
      line.showingBeloptotal = -line.Beloptotal
      line.showingBelop = -line.Belop
      this.creditBilagslinjer.push(line)
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('close')
      }
    },
    openSaveModal: function () {
      if (this.creditBilagslinjer.length < 1) {
        this.$helpers.showErrorAlert('Feil', 'Du må velge minst en linje å kreditere')
        return
      }

      this.openModal('krediterings-bilag-faktura-modal',
        {
          data: this.bilag,
          state: {editableAs: 'normal'},
          lines: this.creditBilagslinjer,
          mottaker: this.kunde,
          internalWindow: true
        },
        'split'
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KrediteringsBilagModal.vue